export default class ExpandedServices {
  constructor(element) {
    console.log("here");
    if (!(element instanceof HTMLElement)) {
      throw new TypeError("Invalid element");
    }

    this.element = element;
    this.button = this.element.parentElement.querySelector('[data-expand-toggle]');

    setTimeout(() => {
      this.initEventHandler();
    }, 100);
  }

  initEventHandler() {
    if(this.button){
      this.button.addEventListener("click", (ev) => {
        if(this.button.classList.contains('active')) {
          return this.close();
        }

        return this.open();
      });
    }

    this.close();
  }

  open() {
    this.element.style.height = `auto`;

    this.button.classList.add('active');
    if(this.button.querySelector('span')){
      this.button.querySelector('span').innerText = "Show less";
    }
  }

  close() {
    const childEl = this.element.querySelector("[data-service-item]:nth-child(6)");

    const parentRect = this.element.getBoundingClientRect();
    const childRect = childEl.getBoundingClientRect();

    const bottomOffset = childRect.bottom - parentRect.top;

    this.element.style.height = `${bottomOffset}px`;

    this.button.classList.remove('active');
    if(this.button.querySelector('span')){
      this.button.querySelector('span').innerText = "Show more";
    }
  }
}
